import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { ItemGroup } from '../data/content';
interface ItemGroupListProps {
  group: ItemGroup;
}
export function ItemGroupList({
  group
}: ItemGroupListProps) {
  return <div className="mt-3" data-id="element-117" data-mp="1fjie6jpyhhel">
      {group.intro && <p className="text-[0.95rem] font-bold text-slate-950" data-id="element-118" data-mp="1bgve5vj4sq6b">{group.intro}</p>}

      {group.variant === 'list' && <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-119" data-mp="1pfv3l5egx93j">
          {group.items.map(item => <li key={item} className="flex gap-2 text-[0.95rem] text-slate-800" data-id="element-120" data-mp="1kibqw9xf54dp">
              <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-orange-700" strokeWidth={4} aria-hidden="true" data-id="element-121" data-mp="1z66ifmzox2p7" />
              {item}
            </li>)}
        </ul>}

      {group.variant === 'inline' && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-122" data-mp="2381kwutcxm4k">
          {group.items.map(item => <li key={item} className="rounded-md bg-slate-900/5 px-2.5 py-1 text-[0.9rem] font-semibold text-slate-950" data-id="element-123" data-mp="1trwsvqo2y34">
              {item}
            </li>)}
        </ul>}

      {group.variant === 'quotes' && <ul className="mt-2 space-y-1.5 border-l-2 border-orange-500 pl-4" data-id="element-124" data-mp="bqmvpfqur0hx">
          {group.items.map(item => <li key={item} className="text-[1rem] font-semibold italic text-slate-950" data-id="element-125" data-mp="goodlxcjktrt">
              “{item}”
            </li>)}
        </ul>}
    </div>;
}